import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  Label,
  LabelList,
} from 'recharts';

const ACCENT_BLUE = 'rgb(34, 93, 153)';
const ACCENT_ORANGE = 'rgb(217, 108, 60)';
const ACCENT_GREEN = 'rgb(99, 179, 100)';
const TEXT_MUTED = 'rgb(147, 160, 181)';
const TEXT_BODY = 'rgb(59, 74, 99)';

const COLORS = [ACCENT_BLUE, ACCENT_ORANGE, ACCENT_GREEN];

const CustomLegend = ({ payload }) => {
  const useTwoColumns = payload.length > 6;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: useTwoColumns ? 'repeat(2, auto)' : '1fr',
        columnGap: '28px',
        rowGap: '14px',
        paddingLeft: '20px',
      }}
    >
      {payload.map((entry, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: entry.color, flexShrink: 0 }} />
          <div>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color: TEXT_BODY }}>
              {entry.value}
            </p>
            <p style={{ margin: 0, fontSize: 12.5, color: TEXT_MUTED }}>
              {entry.payload.percentage} ({entry.payload.value.toLocaleString()})
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

const DonutChart = ({ series, labels, title = 'Total Scans' }) => {
  const data = series.map((value, index) => ({
    name: labels[index],
    value,
  }));

  const totalValue = data.reduce((acc, entry) => acc + entry.value, 0);

  const dataWithPercentages = data.map(entry => ({
    ...entry,
    percentage: totalValue > 0 ? ((entry.value / totalValue) * 100).toFixed(0) + '%' : '0%',
  }));

  const useTwoColumns = dataWithPercentages.length > 6;
  const chartWidth = useTwoColumns ? 620 : 420;

  return (
    <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <PieChart width={chartWidth} height={280}>
        <Pie
          data={dataWithPercentages}
          cx={140}
          cy={140}
          innerRadius={70}
          outerRadius={130}
          paddingAngle={2}
          dataKey="value"
          stroke="none"
        >
          {dataWithPercentages.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
          <LabelList dataKey="percentage" position="inside" fill="#fff" fontSize={13} fontWeight={700} />

          <Label
            value={title}
            position="center"
            style={{ fontSize: '13px', fill: TEXT_MUTED, fontWeight: 600 }}
            dy={-14}
          />
          <Label
            value={totalValue.toLocaleString()}
            position="center"
            style={{ fontSize: '26px', fill: TEXT_BODY, fontWeight: 800 }}
            dy={14}
          />
        </Pie>
        <Tooltip
          contentStyle={{
            borderRadius: '10px',
            border: '1px solid rgba(34, 93, 153, 0.12)',
            fontSize: 13,
            boxShadow: '0 4px 16px rgba(12, 61, 110, 0.12)',
          }}
        />
        <Legend
          layout="vertical"
          verticalAlign="middle"
          align="right"
          content={(props) => <CustomLegend {...props} />}
        />
      </PieChart>
    </div>
  );
};

export default DonutChart;